import React from 'react';
import { AuthProviderInterface } from './auth.provider';

export const AuthContext = React.createContext<AuthProviderInterface | null>(
  null,
);
